import React, { useCallback, useMemo, useState } from 'react';
import { EllipsisOutlined } from '@ant-design/icons';
import { EMOJI_MAP } from '../../EmojiPicker/data';
import { EmojiPicker } from './../../EmojiPicker';
import { Dropdown } from './../../Dropdown';
import { Flex, theme } from 'antd';

const { useToken } = theme;

const getEmojiForReaction = (reaction) => {
  return EMOJI_MAP[reaction] || '❓';
};

export const FrequentEmojis = ({ emojis = [], onClick, onReactionClick }) => {
  const { token } = useToken();
  return (
    <Flex gap={token.paddingXS} align="center" style={{ padding: token.paddingXS }}>
      {emojis.map((emoji) => (
        <Flex className="reaction-button" onClick={() => onReactionClick({ code: emoji })}>
          {getEmojiForReaction(emoji)}
        </Flex>
      ))}
      <Flex style={{ fontSize: '20px', color: token.colorTextSecondary, cursor: 'pointer' }} onClick={onClick}>
        <EllipsisOutlined />
      </Flex>
    </Flex>
  );
};

export const EmojiSelectorButton = React.memo(
  ({
    children,
    showPickerAlways = false,
    topReactions,
    onClick,
    onOpenChange,
    open,
    onClose,
    showRemove,
    placement = 'bottomLeft',
  }) => {
    const [nestedOpen, setNestedOpen] = useState(false);

    const openNestedDropdown = useCallback(() => {
      setNestedOpen(true);
    }, []);

    const onCloseWrapper = useCallback(() => {
      setNestedOpen(false);
      onClose?.();
    }, [onClose]);

    const content = useMemo(
      () =>
        nestedOpen || showPickerAlways ? (
          <EmojiPicker showRemove={showRemove} onClick={onClick} onClose={onCloseWrapper} />
        ) : (
          <FrequentEmojis emojis={topReactions} onClick={openNestedDropdown} onReactionClick={onClick} />
        ),
      [showRemove, onClick, onCloseWrapper, topReactions, nestedOpen, openNestedDropdown, showPickerAlways]
    );

    return (
      <Dropdown
        content={content}
        open={open}
        onOpenChange={(isOpen) => {
          if (!isOpen) setNestedOpen(false);
          onOpenChange?.(isOpen);
        }}
        placement={placement}
      >
        {children}
      </Dropdown>
    );
  }
);

export default EmojiSelectorButton;
